
import { css } from 'lit';
export default css`
pc-search-teaser pc-wysiwyg p{
    color:var(--neutral-medium-gray);
  }`;